/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import BiddingViewed from 'assets/images/modal_marcar_como_lido.png';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import { Container } from './styles';

interface ModalBiddingViewedProps {
  show?: boolean;
  onClose?: () => void;
}

const ModalBiddingViewed = ({ show = false, onClose }: ModalBiddingViewedProps) => {
  const [internalShow, setInternalShow] = useState(false);

  useEffect(() => {
    if (!hasCookie('ModalBiddingViewed')) {
      setInternalShow(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('ModalBiddingViewed', true);
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal show={shouldShow} className="p-0" size="lg" onHide={handleClose}>
      <Container>
        <div className="position-relative text-center bg-white">
          <button type="button" className="close" onClick={handleClose}>
            <span aria-hidden="true">&times;</span>
          </button>
          <img className="card-img-top" src={BiddingViewed} alt="BiddingViewed" />
        </div>
      </Container>
    </Modal>
  );
};

export default ModalBiddingViewed;
